import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Lightweight page wrapper. No loader, just a quick fade-in on route change
 * so the Liquid Glass nav bar stays anchored without any blocking spinner.
 */
export const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  const [key, setKey] = useState(location.pathname);

  useEffect(() => {
    setKey(location.pathname);
  }, [location.pathname]);

  return (
    <div key={key} className="tecly-enter" style={{ width: "100%", minHeight: "100%" }}>
      {children}
    </div>
  );
};
